module.exports = __webpack_public_path__ + "static/img/DSC_0055.0842767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0055.jpg
// module id = TVKm
// module chunks = 0